import { getTotalGalleryAlarmTypeList, getUserDeviceGalleryAlarmTypeList } from '@/api/gallery';
import { IAlarmType, IEvent, IGalleryVideo, IGetDeviceGalleryAlarmTypeListArgs } from '@reolink-cloud/interface';

export interface IAlarmTypeOption {
    label: IAlarmType['name'];
    key: IAlarmType['key'];
    value: IAlarmType['key'];
    selected?: boolean;
    children?: IAlarmTypeOption[];
}

export interface IEventWithExtraInfo extends IEvent {
    coverUrl: string;
    deviceName: string;
    $helperTip: string;
    checked: boolean;
}

export interface IGalleryVideoWithExtraInfo extends IGalleryVideo {
    deviceName?: string;
    coverUrl: string;
    eventId: string;
}

export const getDayZero = ( time: number ): number => {

    const NOW = new Date( time ).getTime();
    return NOW - NOW % 86400000 + new Date().getTimezoneOffset() * 60000;

};

export const getTimeStamp = ( time: number, days: number, type: string ): number => {

    if ( type === 'before' ) {

        return time - days * 24 * 60 * 60 * 1000;

    } else {

        return time + days * 24 * 60 * 60 * 1000;

    }

};

interface IGenerateAlarmTypeOptionsArgs extends Pick<IGetDeviceGalleryAlarmTypeListArgs, 'start_at'|'end_at'> {
    lang?: string;
    uid?: string;
}

/**
 * 生成告警类型选项
 *  - 返回当前设备，当前时间段存在的告警类型
 *  - 不传uid，则返回当前时间段所有设备的告警类型
 * @param {IGenerateAlarmTypeOptionsArgs["uid"]} args.uid 设备uid
 * @returns
 */
export const generateAlarmTypeOptions =
    async ( args: IGenerateAlarmTypeOptionsArgs ): Promise<IAlarmTypeOption[]> => {

        const totalAlarmTypeList = await getTotalGalleryAlarmTypeList( args.lang );

        const deviceList = await getUserDeviceGalleryAlarmTypeList( args );

        let filteredDeviceList = deviceList;

        const alarmTypeOptions: IAlarmTypeOption[] = [];

        if ( args.uid ) {

            filteredDeviceList = deviceList.filter( item => item.uid === args.uid );

        }

        for ( const device of filteredDeviceList ) {

            for ( const alarmType of device.alarmTypes ) {

                for ( const item of totalAlarmTypeList ) {

                    if ( item.key === alarmType.key ) {

                        alarmTypeOptions.push({
                            label: item.name,
                            value: item.key,
                            key: item.key,
                            selected: false
                        });

                    }

                }

            }

        }

        alarmTypeOptions.sort(( a, b ) => {

            if ( a.value > b.value ) return 1;

            else if ( a.value < b.value ) return -1;

            else return 0;

        });

        if ( filteredDeviceList.length > 0 ) {

            alarmTypeOptions.unshift({
                label: 'All',
                value: 'All',
                key: 'all',
                selected: true
            });

        }

        return alarmTypeOptions;

    };
